(function () {
  "use strict";

  var MQ = window.matchMedia("(max-width: 749px)");

  function getMainList() {
    // Most reliable in Dawn: the main product media list inside MainContent
    return document.querySelector("#MainContent .product__media-list.slider.slider--mobile");
  }

  function cleanup(listEl) {
    if (!listEl) return;

    var dots = listEl.parentElement && listEl.parentElement.querySelector(".pdp-gallery-dots");
    if (dots) dots.remove();

    listEl.removeAttribute("data-pdp-dots-init");

    if (listEl._pdpDotsCleanup) {
      try { listEl._pdpDotsCleanup(); } catch (e) {}
      delete listEl._pdpDotsCleanup;
    }
  }

  function init() {
    if (!MQ.matches) {
      cleanup(getMainList());
      return;
    }

    var list = getMainList();
    if (!list) return;

    if (list.getAttribute("data-pdp-dots-init") === "1") return;

    var slides = Array.prototype.slice.call(
      list.querySelectorAll("li.product__media-item.slider__slide, li.slider__slide")
    );

    // Only proceed if this looks like a real media gallery
    if (!slides.length) return;

    // Build dots
    var dots = document.createElement("div");
    dots.className = "pdp-gallery-dots";
    dots.setAttribute("aria-label", "Product media pagination");

    var buttons = slides.map(function (_, idx) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "Go to slide " + (idx + 1));
      b.addEventListener("click", function () {
        slides[idx].scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
      });
      dots.appendChild(b);
      return b;
    });

    list.insertAdjacentElement("afterend", dots);

    function setActive(index) {
      buttons.forEach(function (btn, i) {
        btn.classList.toggle("is-active", i === index);
      });
    }

    setActive(0);

    // Track active slide
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = slides.indexOf(entry.target);
          if (idx >= 0) setActive(idx);
        });
      },
      { root: list, threshold: 0.6 }
    );

    slides.forEach(function (slide) {
      io.observe(slide);
    });

    list._pdpDotsCleanup = function () {
      try { io.disconnect(); } catch (e) {}
    };

    list.setAttribute("data-pdp-dots-init", "1");
  }

  function boot() {
    // Always try init if the main list exists.
    // This makes it work even if body classes are custom.
    cleanup(getMainList());
    init();
  }

  document.addEventListener("DOMContentLoaded", init);

  // Theme Editor reload safety
  document.addEventListener("shopify:section:load", boot);

  // Variant changes can re-render gallery HTML
  document.addEventListener("variant:change", boot);

  // If viewport crosses mobile breakpoint
  if (MQ.addEventListener) MQ.addEventListener("change", boot);
  else if (MQ.addListener) MQ.addListener(boot);
})();
